import React from 'react';
import { Clock, Edit, Eye, Trash } from 'lucide-react';
import NeutralButton from './NeutralButton';
import SecondaryButton from "@/components/SecondaryButton";

const WatchlistCard = ({ watchlist, onView, onDelete }) => {
  const IconComponent = watchlist.icon;

  return (
    <div
      className="bg-white border border-gray-200 rounded-lg p-6 transition-border hover:border-blue-200"
    >
      {/* Title and Icon */}
      <div className="flex items-center gap-3 mb-4">
        {IconComponent && <IconComponent className="text-gray-600" size={20} />}
        <h3 className="text-lg font-semibold text-gray-900">
          {watchlist.name}
        </h3>
      </div>

      {/* Type Tag */}
      <div className="mb-4">
        <span
          className={`inline-block px-3 py-1 rounded text-xs font-medium ${
            watchlist.type === 'static'
              ? 'bg-green-100 text-green-700'
              : 'bg-blue-100 text-blue-700'
          }`}
        >
          {watchlist.type === 'static' ? 'Static' : 'Dynamic'} : {watchlist.stockCount} Stocks
        </span>
      </div>

      {/* Content Section */}
      <div className="space-y-3 mb-6">
        {/* Last Update */}
        <div className="flex items-center gap-2 text-sm text-gray-600">
          <Clock size={14} />
          <span className="text-xs font-medium text-gray-500">
            Last Update
          </span>
          <span className="text-xs text-gray-600">
            {watchlist.lastUpdate}
          </span>
        </div>
      </div>

      {/* Action Buttons */}
      <div className="flex items-center justify-between gap-3 pt-4 border-t border-gray-100">
        <SecondaryButton
          icon={Eye}
          label={"View"}
          textColor={"blue"}
          onClick={() => onView(watchlist.id)}
        />
        <NeutralButton
          icon={Trash}
          label={"Delete"}
          textColor={"red"}
          className='hover:text-white hover:bg-red-500'
          onClick={() => onDelete(watchlist.id)}
        />
      </div>
    </div>
  );
};

export default WatchlistCard;
